import { css } from '@emotion/react';

export const buttonDownload = css`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

export const container = css`
  max-width: 20rem;
`;

export const field = css`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;
